import React from 'react'

function DialogoPenalizacionDelete (props) {
  const { patente } = props

  return (
    <>
      <h4 style={{ width: '80%', margin: 'auto' }}>
          Confirmando le quitará la penalización a la patente <strong>{patente}</strong>.
      </h4>
    </>
  )
}

export default DialogoPenalizacionDelete
